import React, { useState } from "react";
import {
  Route,
  Routes as BrowserRoute,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Header from "../components/Header";
import ProductPage from "pages/ProductPage";
import ProductDetailPage from "pages/ProductDetailPage";
import LoginSignupPage from "pages/LoginSignupPage";
import ProjectPage from "pages/ProjectPage";
import ProjectDetailPage from "pages/ProjectDetailPage";
import { UserContext } from "components/UserContext";
import EditProject from "pages/editProject";
import Finalsubmittal from "pages/finalSubmittal";
import PrivacyPolicy from "pages/PrivacyPolicy";
import MainSubmittal from "pages/submittalMain";
import TermsOfUse from "pages/TermsOfUse";
import ResetPassword from "components/resetPassword";
import ChangePassword from "pages/ChangePassword";
import EditProfile from "pages/editProfile";
import SelectDocument from "pages/selectDocument";
import BrochureMain from "pages/brochure/brochureMain";
import FinalBrochure from "pages/brochure/finalBrochure";
import CreateProjectTools from "pages/CreateProjectTools";
import MifabHome from "components/MifabHome";
import CreateProjectForm from "pages/CreateProjectForm";

import CreateQuotationProjectForm from "pages/createQuotationProjectForm";
import MifabAbout from "components/MifabAbout";
import ContactPage from "pages/contactus";
import Footer from "components/Footer";
import ProjectResults from "pages/ProjectResults";

const Routes = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [menu, setMenu] = useState(false);
  const [login, setLogin] = useState(false);
  const onMenu = () => {
    if (window.innerWidth <= 991) {
      setMenu(!menu);
    }
  };

  const [showMenu, setShowMenu] = useState();
  const onMenuOpen = () => {
    setShowMenu(!showMenu);
  }

  const onLogin = () => {
    setLogin(!login);
    navigate("/products");
  };

  const onboardingPage = ["/login-signup"];
  const hideComponent = onboardingPage.includes(location.pathname)
    ? false
    : true;

  const [values, setValues] = useState("PI from Context");

  const token = localStorage.getItem("mytoken");


  return (
    <div className={`wrapper ${menu ? "showMenu" : ""}`}>
      <UserContext.Provider value={values}>
        {hideComponent ? <Header onMenu={onMenu} showMenu={menu} onMenuOpen={onMenuOpen} isOpen={showMenu} /> : null}
        <main id="main">
          <BrowserRoute>
            <Route exact path={"/"} element={<MifabHome />} />
            <Route exact path={"/about"} element={<MifabAbout />} />
            <Route exact path={"/contact"} element={<ContactPage />} />
            {/* <PrivateRoute path="/" render={<HomePage />} /> */}
            <Route path={"/products"} element={<ProductPage />} />
            <Route
              path={"/product-detail/:id"}
              element={<ProductDetailPage />}
            />
            <Route
              path={"/login-signup"}
              element={<LoginSignupPage login={onLogin} />}
            />
            <Route path={"/reset-password/:id"} element={<ResetPassword />} />
            <Route path={"/edit-profile"} element={<EditProfile />} />
            <Route path={"/change-password"} element={<ChangePassword />} />
            <Route path={"/projects"} element={<ProjectPage />} />
            <Route path={"/termsofuse"} element={<TermsOfUse />} />
            <Route
              path={"/project-detail/:id"}
              element={<ProjectDetailPage />}
            />
            <Route path={"/edit-project/:id"} element={<EditProject />} />
            <Route path={"/createSubmittal/:id"} element={<MainSubmittal />} />
            <Route
              path={"/create-project-tools/:id"}
              element={<CreateProjectTools />}
            />
            <Route path={"/selectDocument/:id"} element={<SelectDocument />} />
            <Route path={"/createBrochure/:id"} element={<BrochureMain />} />
            <Route
              path={"/createProjectForm"}
              element={<CreateProjectForm />}
            />
            <Route path="/project-results" element={<ProjectResults />} />
            <Route
              path={"/createQuotationProjectForm"}
              element={<CreateQuotationProjectForm />}
            />
            {/* <Route path={'/create-submittal'} element={<CreateSubmittal />} /> */}
            {/* <Route path={'/generate-submittal'} element={<GenerateSubmittal />} /> */}
            <Route path={"/final-submittal"} element={<Finalsubmittal />} />
            <Route path={"/final-brochure"} element={<FinalBrochure />} />

            <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
            <Route path={"/view-project/:id"} element={<PrivacyPolicy />} />
            {/* <Route path={'/manufacturer-websites'} element={<ManufacturerWebsite />} /> */}
          </BrowserRoute>
        </main>
        <Footer />
      </UserContext.Provider>
    </div>
  );
};
export default Routes;
